//
// Lookup tables (operator, 13./14.10.2026): a data list without a template is a
// table of its own, addressed by name — "Laender.Bezeichnung" in the query
// builder and in args.data. No imports: client and server both use it.
//

/**
 * The name a lookup table gets unless one is typed: its sheet name. A dot
 * would split "Name.Field" in the wrong place, so it becomes an underscore.
 */
export const defaultLookupName = (sheetName: string) => String(sheetName ?? '').trim().replace(/\./g, '_')

/** Whether a name can address a lookup table: not empty, no dot. */
export const isValidLookupName = (name: string) => !!String(name ?? '').trim() && !String(name).includes('.')
